import React, { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(
    JSON.parse(localStorage.getItem("newauth")) || null
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (auth) {
      localStorage.setItem("newauth", JSON.stringify(auth));
    } else {
      localStorage.removeItem("newauth");
    }
  }, [auth]);

  const logout = () => {
    setAuth(null);
    navigate("/login"); // Redirect to login page after logout
  };

  const [au, setAu] = useState(null);
  const [uu, setUu] = useState(null);
  const [cv, setcv] = useState(null);
  const [tau, settAu] = useState(null);
  const [tuu, settUu] = useState(null);
  const [tcu, settcu] = useState(null);

  const initial = {
    email: "",
    amount: "",
    reference: "",
    totalAmount: "",
  };

  const all = {
    au: "",
    uu: "",
    uw: "",
    tau: "",
    tuu: "",
    tav: "",
    tuv: "",
    tcu: "",
    tvoucher: "",
    uvoucher: "",
  };

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        logout,
        navigate,
        au,
        setAu,
        uu,
        setUu,
        all,
        cv,
        setcv,
        tau,
        settAu,
        tcu,
        settcu,
        tuu,
        settUu,
        initial,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
